// 展会中心接口 -09.11
let Api = {
     "EXPOINFO_LOOKBACKDETAIL": "/operations/n/index/expoInfo/LookBackDetail", //门户展会中心-根据会展回顾ID查询详细信息
     "EXPOINFO_EXPOINFODETAIL": "/operations/n/index/expoInfo/expoInfoDetail", //门户展会中心-展会详细信息查询
     "EXPOINFO_FINDLIST": "/operations/n/index/expoInfo/findList", //门户展会中心-展会列表(推荐展会/展会公告)
     "EXPOINFO_LOOKBACKLIST": "/operations/n/index/expoInfo/lookBackList", //门户展会中心-精彩回顾列表
     "EXPOINFO_EXPOINFODETAIL": "/operations/n/index/expoInfo/expoInfoDetail", //门户展会中心-展会详细信息查询
     "EXPOINFO_FINDINFORNATIONLIST": "/operations/n/app/expoInfo/findInfornationList", //根据会展ID查询会展动态列表
     "EXPOINFO_FINDACTIVITYPAGE": "/operations/n/app/expoInfo/findActivityPage", //活动-根据会展ID查询活动列表
     "EXPOINFO_GETINFORDETAIL": "/operations/n/app/expoInfo/getInforDetail", //根据ID查询展会动态详细信息
     "EXPOINFO_GETACTIVITYDETAIL": "/operations/n/app/expoInfo/getActivityDetail", //根虎ID查询活动详细信息
     "CUSTOMSTRADEDATA_STATISTICS": "/operations/n/CustomsTradeData/statistics", //数据分析地图
     "QPSTZX_INDEX_EXPOTJ": "/simple-api/n/qpstzx/index/expoTj", //地图以及统计信息接口
     "QPSTZX_INDEX_EXPOINFO": "/operations/n/index/expoInfo/findList", //地图以及统计右侧展会列表

	"OPERATIONS_EXPOINFO_FINDFORSEARCH": "/operations/n/index/expoInfo/findForSearch", //门户一站式搜索-查询会展列表
	"OPERATIONS_EXPOINFO_FINDTJFORSEARCH": "/operations/n/index/expoInfo/findTjForSearch", //门户一站式搜索-查询会展列表(推荐)

     "SHOPHOME_FINDESPRODUCTINFO": "/b2b/n/ShopHome/findEsProductInfo", //商品详情
}
module.exports = Api